import { render } from "./EventItem.vue?vue&type=template&id=6b91f757"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"

import "./EventItem.vue?vue&type=style&index=0&id=6b91f757&lang=css"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Event/Manage/EventItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b91f757"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b91f757', __exports__)) {
    console.log('reload')
    api.reload('6b91f757', __exports__)
  }
  
  module.hot.accept("./EventItem.vue?vue&type=template&id=6b91f757", () => {
    console.log('re-render')
    api.rerender('6b91f757', render)
  })

}


export default __exports__